import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { PlannerDataProvider } from "./state/PlannerDataContext";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <React.StrictMode>
    <PlannerDataProvider>
      <App />
    </PlannerDataProvider>
  </React.StrictMode>
);
